const guard = {
    invalid_input: 'La solicitud {{type}} es inválida.',
    invalid_pagination: 'El valor de paginación de la solicitud es inválido.',
    can_not_get_tenant_id: 'No se puede obtener el ID del inquilino de la solicitud.',
    file_size_exceeded: 'Se excedió el tamaño del archivo.',
    mime_type_not_allowed: 'El tipo MIME no está permitido.',
};
export default guard;
